require([
	'jquery',
	'root/Base/Js/MbiMediaQuery'
], function(
	$,
	mbiMq
	) {

	'use strict';


	var menuOffset = 0;

	$('.menu__level0 .menu__submenu').click(function(e){
		if($(this).children('.menu__entry').next().hasClass('is-active')) {
			$('.menu__entry').next().removeClass('is-active');
			$('.menu__entry').removeClass('is-active');
			$('.menu__entry').next().next().removeClass('is-active');
		} else {
			$('.menu__entry').removeClass('is-active');
			$('.menu__entry').next().removeClass('is-active');
			$('.menu__entry').next().next().removeClass('is-active');
			$(this).children('.menu__entry').addClass('is-active')
			$(this).children('.menu__entry').next().addClass('is-active');
			$(this).children('.menu__entry').next().next().addClass('is-active');
		}
	});

	$(document).on('click', '.js_showMenu',function(e){
		e.preventDefault();
		e.stopPropagation();
		$('html').addClass('showMenu');
		setTimeout(function() {
			$('html').addClass('menufixed');
		}, 300);
		lockBody(true, 100);
		menuOffset = window.pageYOffset; // get current scroll position
	});


	$(document).on('click', '.js_hideMenu',function(e){
		e.preventDefault();
		e.stopPropagation();
		$('.menu__entry').next().removeClass('is-active');
		$('html').removeClass('showMenu');
		setTimeout(function() {
			$('html').removeClass('menufixed');
		}, 300);
		lockBody(false, 100);
		$('body, html').scrollTop(menuOffset); // scroll to previous position
		menuOffset = 0; // reset scroll position
	});

	function lockBody(lock, timeout) {
		setTimeout(function() {
			if (lock) {
				$('#main, #footer').addClass('noscroll');
			} else {
				$('#main, #footer').removeClass('noscroll');
			}
		}, timeout);
	}

	function moveFooterMenu() {

		var $footer = $('.footer-menu__logo'),
			$footerMenu = $('.footer-menu .menu__level0'),
			$header = $('.main-menu'),
			$headerMenu = $header.children('.menu__level0');

		if ('portrait-' in mbiMq.mqArea) {
			if ($footerMenu.length > 0) {
				$footerMenu.detach().appendTo($header).addClass('footer-menu');
			}
		} else {
			if ($headerMenu.length > 1) {
				$footer.after($headerMenu.last().detach());
				$('.footer-menu .menu__level0').removeClass('footer-menu');
			}
		}
	}


	moveFooterMenu();

	$(document).on('breakpoint', function(){

		moveFooterMenu();

		if ('landscape+' in mbiMq.mqArea) {
			$('#main, #footer').removeClass('noscroll');
		}

	});





	// function handleSubmenuMobile() {
	// 	if ('lap-' in mbiMq.mqArea) {
	// 		$('.menu__level0 .menu__submenu').click(function(e){
	// 			e.preventDefault();
	// 			e.stopPropagation();
	// 			alert('test');

	// 			$('.menu__submenu').next().removeClass('is-active');
	// 			$(this).next().addClass('is-active');
	// 		});
	// 	}
	// }


	/*

	$(document).on('click', '.js_showMenu',function(e){
		e.preventDefault();
		e.stopPropagation();
		$('html').addClass('showMenu');
		lockBody(true, 100);
		menuOffset = window.pageYOffset; // get current scroll position
	});

	$(document).on('click', '.js_hideMenu',function(e){
		e.preventDefault();
		e.stopPropagation();
		$('.js_menu__entry').next().removeClass('is-active');
		$('html').removeClass('showMenu');
		lockBody(false, 100);
		$('body, html').scrollTop(menuOffset); // scroll to previous position
		menuOffset = 0; // reset scroll position
	});

	handleSubmenuMobile();
	$(document).on('breakpoint', function(){
		handleSubmenuMobile();
	});
	*/

});
define("root/Assets/Templates/Html/FullHeader/Js/FullHeader", function(){});

